import { render, staticRenderFns } from "./TransferDriverEntity.vue?vue&type=template&id=672b91f0&"
import script from "./TransferDriverEntity.vue?vue&type=script&lang=js&"
export * from "./TransferDriverEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('672b91f0')) {
      api.createRecord('672b91f0', component.options)
    } else {
      api.reload('672b91f0', component.options)
    }
    module.hot.accept("./TransferDriverEntity.vue?vue&type=template&id=672b91f0&", function () {
      api.rerender('672b91f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TransferDriverEntity.vue"
export default component.exports